import React, { useCallback, useState } from 'react';
import { usePortletStore } from '../App';
import CommunicationUtil from '../util/CommunicationUtil';
import type { OtpConfirmationControlHandle } from 'ehs-react';
import { OtpConfirmationControl } from 'ehs-react';
import { OtpContinueButton } from './OtpContinueButton';

function AuthenticationWizardOtpConfirmationPage({
  onNextPage
}: Readonly<{
  onNextPage: () => void;
}>): React.JSX.Element {
  const [lengthOfCode] = usePortletStore(state => [
    state.configuration.lengthOfOtp
  ]);
  const otpRef = React.useRef<OtpConfirmationControlHandle>(null);
  const [isOptNextButtonDisabled, setIsOptNextButtonDisabled] = useState(true);

  const onOtpValid = useCallback((): void => {
    onNextPage();
  }, [onNextPage]);

  return (
    <>
      <OtpConfirmationControl
        ref={otpRef}
        autoFocusFirstInput={true}
        onOtpValid={onOtpValid}
        onOtpEntered={code => setIsOptNextButtonDisabled(code.length === 0)}
        lengthOfCode={lengthOfCode}
        validateAuthenticationCodeCall={
          CommunicationUtil.validateAuthenticationCode
        }
        sendAuthenticationCodeCall={CommunicationUtil.sendAuthenticationCode}
        autoSubmit={false}
      />
      <OtpContinueButton
        onContinueClick={() =>
          otpRef.current
            ? otpRef.current.submitOtp()
            : console.warn('OTP ref is null')
        }
        disabled={isOptNextButtonDisabled}
      />
    </>
  );
}

export default AuthenticationWizardOtpConfirmationPage;
